import { api, apiClient } from "../lib";
import {
  getResponseDownloadFilename,
  triggerBlobDownload,
} from "../utils/downloadFilename";

export interface TcTechnicalSummaryEligibility {
  eligible: boolean;
  status: string | null;
}

export const TC_TECHNICAL_SUMMARY_TIMEOUT_MS = 60000;

export const tcTechnicalSummaryService = {
  getEligibility: (caseId: string) =>
    api.get<TcTechnicalSummaryEligibility>(
      `/cases/${caseId}/technical-summary/eligibility`
    ),

  getPdf: (caseId: string, disposition: "inline" | "attachment") =>
    apiClient.get(`/cases/${caseId}/technical-summary/pdf`, {
      params: { disposition },
      responseType: "blob",
      timeout: TC_TECHNICAL_SUMMARY_TIMEOUT_MS,
    }),

  download: async (caseId: string) => {
    const response = await tcTechnicalSummaryService.getPdf(
      caseId,
      "attachment"
    );
    const filename = getResponseDownloadFilename(
      response.headers["content-disposition"],
      "technical-summary.pdf"
    );
    triggerBlobDownload(
      new Blob([response.data as BlobPart], { type: "application/pdf" }),
      filename
    );
  },
};
